import { store } from "../store";

/**
 * Multi language string loader
 * zelfde functie als in CoreCalls maar dan voor de backend. Met wat kleine aanpassingen
 */
export const getText = (type, name, defaultText, replaceList = [], lang = null) => {
  //Fallback als de store nog niet is gezet
  if (store === undefined) {
    return defaultText;
  }

  let localStrings = null;
  try {
    localStrings = {}; // todo require("./" + type + ".json");
  } catch (fileError) {
    return defaultText;
  }
  let resString;
  let langCode = "NL"; //Fallback lang

  if (lang) {
    langCode = lang.toUpperCase();
  }
  if (!lang && store.getState().user !== undefined && store.getState().user.lang !== undefined) {
    langCode = store.getState().user.lang.toUpperCase();
  }

  if (localStrings[name] !== undefined && localStrings[name][langCode] !== undefined) {
    resString = localStrings[name][langCode];
  } else {
    /**
     * Geen warn teveel shit in console!
     */
    // console.log("Text not found in language table: ", type, name, langCode, defaultText);
    // if(typeof Sentry !== "undefined"){
    //     Sentry.captureMessage('Text not found in language table: ' + type + ', ' + name + ', ' + langCode + ', ' + defaultText + ', ', "info");
    // }
    resString = defaultText;
  }
  replaceList.forEach((replaceValue, replaceIndex) => {
    resString = resString.replace("[" + replaceIndex + "]", replaceValue);
  });
  return resString;
};

/**
 * Helper functie voor getText
 * @param type
 * @param name
 * @param defaultText
 * @param replaceList
 * @returns {*}
 * @private
 */
export const __ = (type, name, defaultText, replaceList = []) => {
  return getText(type, name, defaultText, replaceList);
};
